define('views/modules/calendar/calendar/calendar-component/item/calendar-item-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/list',
    'views/modules/feedback/modal/feedback-modal-mixin',
    'views/modules/calendar/calendar/calendar-component/item/calendar-day-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VList,
    VFeedbackModalMixin,
    VCalendarDayItem
) {

    var VCalendarItemList = VList.extend(_.extend({
        item: VCalendarDayItem,

        initialize: function(opt) {
            _.extend(this, { role: opt.role });
            this.initFeedbackListener();
        },

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, 'url', 'summary'));
        },
    }, VFeedbackModalMixin));

    return VCalendarItemList;
});

